import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class LeadsAdminService extends BaseService<any> {
  constructor() {
    super(`leads`);
  }

  getLeads = async (queryParams = {}) => {
    return appAxios.get(`${this.pathWithOrg()}`, { params: queryParams });
  };

  addContactToLead = async (leadID: number, contactID: string) => {
    return appAxios.post(`${this.pathWithOrg()}/${leadID}/contacts`, { contactID });
  };

  deleteContactFromLead = async (leadID: number, contactID: string) => {
    return appAxios.delete(`${this.pathWithOrg()}/${leadID}/contacts/${contactID}`);
  };

  getLeadsCount = async (queryParams = {}) => {
    return appAxios.get(`${this.pathWithOrg()}/stats/count`, { params: queryParams });
  };
}

export enum LeadSource {
  WHATSAPP = 'WHATSAPP',
  TELEGRAM = 'TELEGRAM',
  INSTAGRAM = 'INSTAGRAM',
  WEBSITE = 'WEBSITE',
  CALL = 'CALL',
}

/**
 * Статусы лидов
 * Статусы в AmoCRM (воронка продаж)

    1. Неразобранные
    Все входящие заявки (сайт, WhatsApp, звонки и т.п.), которые ещё никто не взял в работу. Пока ответственный менеджер не взял в работу, статус не меняется.

    2. Первичный контакт
    Менеджер связался с лидом первый раз: уточнил детали, представился. Если менеджер меняет статус на это, значит он взял в работу этот лид.

    3. Переговоры
    Идёт обсуждение условий, цен, дат, вариантов тура.

    4.Принимает решение
    Клиент думает, советуется с семьёй/партнёром, рассматривает предложение.

    5. Согласование договора
    Клиент почти готов — обсуждают финальные условия, документы, оплаты.

    6. Успешно реализовано
    Сделка закрыта успешно → лид стал клиентом, тур куплен.

    7. Закрыто и нереализовано
    Сделка закрыта неуспешно → клиент отказался, потерялся или выбрал конкурентов.
 */
export enum LeadStatus {
  NEW = 'NEW',
  WON = 'WON',
  LOST = 'LOST',
}



export default new LeadsAdminService();
